module.exports = __webpack_public_path__ + "img/jscl.dfd46c1f.png";